import React, { useState } from 'react';

import FileInput from '../FileInput';

const UploadFile = ({
  dataCy,
  label,
  value,
  error,
  helper,
  accept,
  multiple,
  tooltip,
  tooltipPlacement,
  variant,
  icon,
  color,
  getFileLabel,
  getFileKey,
  onUpload,
  onRemove,
  disabled,
  direction,
  fileLabels,
  children,
  ...props
}) => {
  const [loading, setLoading] = useState(false);

  const handleUpload = async (e, files) => {
    if (!files.length) {
      return;
    }

    const filesFormData = files.map((file) => {
      const formData = new FormData();
      formData.append(
        'file',
        new Blob([file], { type: 'application/octet-stream' }),
        file.name
      );

      return formData;
    });

    setLoading(true);

    const response = await onUpload(e, filesFormData);

    setLoading(false);

    return response;
  };

  return (
    <FileInput
      dataCy={dataCy}
      label={label}
      value={value}
      error={error}
      helper={helper}
      accept={accept}
      multiple={multiple}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
      variant={variant}
      icon={icon}
      color={color}
      getFileLabel={getFileLabel}
      getFileKey={getFileKey}
      onUpload={handleUpload}
      onRemove={onRemove}
      loading={loading}
      disabled={disabled}
      direction={direction}
      fileLabels={fileLabels}
      {...props}
    >
      {children}
    </FileInput>
  );
};

export default UploadFile;
